import { AnyAction } from 'redux';
import { DocumentMetaType } from 'types/document';
import { Error } from 'types/error';
import {
  FETCH_DOCUMENT_META_ERROR,
  FETCH_DOCUMENT_META_START,
  FETCH_DOCUMENT_META_SUCCESS,
  FETCH_DOCUMENT_FILE_SUCCESS,
  FETCH_DOCUMENT_FILE_ERROR,
  FETCH_TRANSLATION,
  FETCH_TRANSLATION_ERROR,
} from 'actions/documentMeta/types';
import { TranslationType } from 'types/translation';

export type DocumentReducerType = {
  isLoading: boolean;
  documentMeta: DocumentMetaType | null;
  error: Error | null;
  isFetchFile: boolean;
  errorFile: Error | null;
  lang: TranslationType;
  isTranslate: boolean;
};

export const initialState = (): DocumentReducerType => ({
  isLoading: true,
  documentMeta: null,
  error: null,
  isFetchFile: false,
  errorFile: null,
  lang: {} as TranslationType,
  isTranslate: false,
});

export default function DocumentReducer(
  state = initialState(),
  action: AnyAction
) {
  switch (action.type) {
    case FETCH_DOCUMENT_META_START: {
      return {
        ...state,
      };
    }
    case FETCH_DOCUMENT_META_SUCCESS:
      return {
        ...state,
        isLoading: false,
        documentMeta: action.documentMeta,
      };
    case FETCH_DOCUMENT_META_ERROR:
      return {
        ...state,
        isLoading: false,
        error: { ...action.error },
      };
    case FETCH_DOCUMENT_FILE_SUCCESS:
      return {
        ...state,
        isFetchFile: true,
      };
    case FETCH_DOCUMENT_FILE_ERROR:
      return {
        ...state,
        errorFile: { ...action.error },
      };
    case FETCH_TRANSLATION:
      return {
        ...state,
        lang: action.lang,
        isTranslate: true,
      };
    case FETCH_TRANSLATION_ERROR:
      return {
        ...state,
        errorFile: { ...action.error },
      };
    default:
      return state;
  }
}
